import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCVEfMtBcOq9u1JD91ctLGWtIwO-cSvgP0",
    authDomain: "zeiterfassung-cfdf4.firebaseapp.com",
    projectId: "zeiterfassung-cfdf4",
    storageBucket: "zeiterfassung-cfdf4.firebasestorage.app",
    messagingSenderId: "515617937728",
    appId: "1:515617937728:web:f5da6624c1d7c9b9e882a5",
    measurementId: "G-G6JNDE2YKN"
};

// Öffentlicher reCAPTCHA-Enterprise-Websiteschlüssel (kein Geheimnis).
// Gültig für zeit.ellin-grill.de – angelegt in Google Cloud > Fraud Defense.
const RECAPTCHA_ENTERPRISE_SITE_KEY = "6LcbX-8tAAAAAHW5BO_YU4qCsl54hmP34-CP-fIu";

const app = initializeApp(firebaseConfig);

// Lokale Entwicklung: localhost ist nicht im reCAPTCHA-Schlüssel freigegeben.
// Stattdessen erzeugt das SDK ein Debug-Token, das in der Browser-Konsole
// ausgegeben wird und einmalig in Firebase > App Check > Apps > Tracker >
// "Debug-Tokens verwalten" eingetragen werden muss.
if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// App Check muss vor dem ersten Firestore-/Auth-Zugriff initialisiert werden,
// damit jede Anfrage ein Attestierungs-Token mitschickt.
let appCheck = null;
try {
    appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
        isTokenAutoRefreshEnabled: true
    });
} catch (e) {
    // Solange App Check in der Konsole nur überwacht (nicht erzwungen) wird,
    // darf ein Fehler hier die App nicht blockieren.
    console.error('App Check konnte nicht initialisiert werden:', e);
}

const auth = getAuth(app);
const db = getFirestore(app);
// Login/PIN-Funktionen laufen serverseitig (Region wie die übrigen Functions)
const functions = getFunctions(app, 'us-central1');
const appId = 'ellin-zeiterfassung';
const LOGO_URL = "/Logo-500x500.png";

export { app, appCheck, auth, db, functions, appId, LOGO_URL };
